/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilebillingpayer2Inputs */

const en_profilebillingpayer2 = /** @type {(inputs: Profilebillingpayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoice to`)
};

const de_profilebillingpayer2 = /** @type {(inputs: Profilebillingpayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechnung an`)
};

/**
* | output |
* | --- |
* | "Invoice to" |
*
* @param {Profilebillingpayer2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilebillingpayer2 = /** @type {((inputs?: Profilebillingpayer2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilebillingpayer2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilebillingpayer2(inputs)
	return de_profilebillingpayer2(inputs)
});
export { profilebillingpayer2 as "profileBillingPayer" }